import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation unreportGroupPost($groupPostId: String!) {
    unreportGroupPost(groupPostId: $groupPostId) {
      success
      message
    }
  }
`

export interface UnreportGroupPostInput {
  groupPostId: string
}

export interface UnreportGroupPostOutput {
  unreportGroupPost: {
    success: boolean
    message: string
  }
}

export const useUnreportGroupPost = () =>
  useMutation<UnreportGroupPostOutput, UnreportGroupPostInput>(mutation)
